import styled, { css } from 'styled-components';

export const Root = styled.div`
  position: relative;
  z-index: 10;
`;

export const Select = styled.button`
  height: 32px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(10, 8, 30, 0.7);
  backdrop-filter: blur(10px);
  color: #fff;
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    border-color: rgba(155, 89, 182, 0.5);
    background: rgba(20, 16, 50, 0.8);
  }
`;

export const ChainDot = styled.span<{ $color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const Arrow = styled.span<{ $open?: boolean }>`
  font-size: 12px;
  opacity: 0.5;
  transition: transform 0.2s;
  ${({ $open }) =>
    $open &&
    css`
      transform: rotate(180deg);
    `}
`;

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 180px;
  max-height: 360px;
  overflow-y: auto;
  border-radius: 12px;
  border: 1px solid rgba(155, 89, 182, 0.3);
  background: rgba(10, 8, 30, 0.95);
  backdrop-filter: blur(15px);
  padding: 4px 0;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(155, 89, 182, 0.3);
    border-radius: 2px;
  }

  @media (max-width: 600px) {
    right: auto;
    left: 0;
  }
`;

export const ChainItem = styled.button<{ $isSelected?: boolean }>`
  width: 100%;
  height: 34px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: ${({ $isSelected }) => ($isSelected ? 'rgba(155, 89, 182, 0.15)' : 'transparent')};
  color: ${({ $isSelected }) =>
    $isSelected ? 'rgba(155, 89, 182, 0.9)' : 'rgba(255, 255, 255, 0.8)'};
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
